module.exports = __webpack_public_path__ + "media/images/number_2-a87937cab8f249d96ff9d9f9c4a5c664.png";